import { useState, type PropsWithChildren } from "react";
import {
  PrimaryNavigationStripSurfaceContext,
  createPrimaryNavigationStripSurfaceRegistry,
} from "#primary-navigation-strip-surface-context";

/**
 * Wraps the tab navigator so accordion scenes can claim a white fade/background while Learn and
 * other muted pages keep the default muted wash.
 */
export function PrimaryNavigationStripSurfaceProvider({ children }: PropsWithChildren) {
  const [registry] = useState(() => createPrimaryNavigationStripSurfaceRegistry());
  return (
    <PrimaryNavigationStripSurfaceContext.Provider value={registry}>
      {children}
    </PrimaryNavigationStripSurfaceContext.Provider>
  );
}
